export const ALL_ROW_FILTER_OPTION = 'All';
